module dg.navigation {

    export class MenuItemController {
        public link: dg.restfulApi.Link;
        public stateName: string;

        public constructor(private navigationService: dg.navigation.NavigationService,
            private $state: ng.ui.IStateService) {
        }

        $onChanges = (changes) => {
            if (this.link && !this.link.disabledReason) {

                this.stateName = this.navigationService.getState(this.link).name;
            }
        }

        public linkClick = ($event) => {
            //$event.stopPropagation();
            $event.preventDefault();

            if (this.link) {
                this.navigationService.navigate(this.link);
            }
        }

    }

    angular.module('dg.navigation')
        .component('menuItem', {
            bindings: {
                link: '<'
            },
            controller: (MenuItemController as any),
            templateUrl: '/digmo/src/navigation/menu-item.html'
        });
}